import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import React from 'react';
import { ILinesChartCard, InventoryChartCard } from './InventoryChartCard';
import { Close } from '@mui/icons-material';
import { useMaterialsStore } from '../../../components/Stores/MaterialsStore';
import { useCurrencyRates } from '../../../hooks/useCurrencyRates';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export const InventoryDetails: React.FC<ILinesChartCard> = ({
  selectedMaterial: materialId,
  inventoryReports,
  selectedYear,
  colorsMap,
  refetchData,
  terminals,
  isTerminals,
  setIsTerminals,
  setIsQuantity,
  isQuantity,
  editable,
  close = () => 0,
}) => {
  const { materialsMap } = useMaterialsStore();

  return (
    <div className="bg-white flex flex-col p-4 *gap-4 min-w-96">
      <div className="flex flex-row justify-between">
        <h4>
          Inventory details
          <span style={{ color: colorsMap[materialId || ''] || '#000' }}> {materialsMap[materialId || '']?.name}</span>
        </h4>
        <Close className="cursor-pointer align-self-baseline text-purple me-1" onClick={close} />
      </div>
      <InventoryChartCard
        inventoryReports={inventoryReports}
        selectedMaterial={materialId}
        selectedYear={selectedYear}
        colorsMap={colorsMap}
        refetchData={refetchData}
        {...{ setIsTerminals, isTerminals, terminals, editable, setIsQuantity, isQuantity }}
        isPopup
      ></InventoryChartCard>
    </div>
  );
};
